import { TimeSlotRequestDto, TimeSlotResponseDto } from '../dtos/timeslot';
import { TimeSlotRequest, TimeSlotResponse } from '../models/timeslot';

export const dtoToTimeSlotResponse = (request: TimeSlotResponseDto): TimeSlotResponse => {
  const { timeslots } = request;
  return {
    timeslots
  };
};

export const timeslotRequestToDto = (request: TimeSlotRequest): TimeSlotRequestDto => {
  const { maxDays, dropoff } = request;
  const { coordinate } = dropoff;
  return {
    max_days: maxDays,
    dropoff: {
      coordinate
    }
  };
};
